const processType = {
    sell: 1,
    correction: 2
};

export default processType;
